import React, { useEffect, useRef, useState, useLayoutEffect, useContext } from 'react'
import './StockAnalysisReport.scss'
import { Col, Container, Form, InputGroup, Row, Image } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-solid-svg-icons';
import reportImage from '../../../assets/img/reports-image.svg';
import { ReportServiceApi } from "../../../services/stockAnalysis/api";
import { Configuration } from "../../../services/stockAnalysis/configuration"
import { useDispatch, useSelector } from "react-redux";
import { set } from 'lodash';
import ErrorContent from '../../../components/error-boundary';
import Spinner from '../../../components/spinner';
import { AttachmentApi } from '../../../services/actionHub'
import { Configuration as AttachmentConfig } from "../../../services/actionHub/configuration"
import { Toast } from 'primereact/toast';
import { downloadFile, downloadPdf } from '../../../helpers/utils';
import { APIControl } from '../../../helpers/APIControl';
import ParallelButtonSelection from '../../../components/selections/periodSelection/parallelButtonSelection';
import { useTranslation } from "react-i18next";
export default function StockAnalysisReport() {
    const { t } = useTranslation();
    const api = new ReportServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH));
    const attachmentApi = new AttachmentApi(new Configuration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));

    const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);

    const token = useSelector((state) => state.auth?.token);

    const toast = useRef(null);
    const [selectedTheme, setSelectedTheme] = useState();
    const [stateReportategoryActive, setstateReportCategoryActive] = useState([{ id: 11 }]);
    const [reportListData, setReportListData] = useState([])

    const [entityId, setEntityId] = useState(undefined)

    const [isLoading, setIsLoading] = useState(true);
    const [panelError, setPanelError] = useState(false);

    //    11,     //Financial
    //    7,      //Annual
    //    17,     //AnalystPresentations
    //    202,    //Circular
    //    6,      //Other
    //    12      //Researchs


    const reportListTitles = [
        {
            id: 11,
            name: t('reports.categories.financialReports'),
            categoryCode: "financial"
        },
        {
            id: 7,
            name: t('reports.categories.activityReports'),
            categoryCode: "annual"

        },
        {
            id: 17,
            name: t('reports.categories.companyPresentation'),
            categoryCode: "analystPresentations"
        }
    ]

    useEffect(() => {

        if (selectedSecurity.code) {
            setEntityId(selectedSecurity.id)
        }

    }, [selectedSecurity])

    useEffect(() => {
        if (stateReportategoryActive && entityId) {
            getReportData();
        }
    }, [stateReportategoryActive, entityId]);


    //#region API CALLS
    //#region REPORTDATA

    const getReportData = () => {

        setIsLoading(true);
        setPanelError(false);
        setReportListData([]);

        let culture = "tr-TR"

        if (stateReportategoryActive.length == 0 || stateReportategoryActive[0].id == undefined || entityId == undefined || token == undefined || culture == undefined) {
            setIsLoading(false);
            setPanelError(true);
            return;
        }

        api.reportListGet(token, culture, entityId, stateReportategoryActive[0].id)

            .then((res) => {

                if (res.data?.error) {
                    setPanelError(true)
                    setIsLoading(false)
                    return;
                }

                const data = res.data?.categories?.[0]?.items ?? [];

                if (!Array.isArray(data)) {
                    setPanelError(true)
                    setIsLoading(false)
                    return;
                }

                data.forEach(element => {
                    const year = element.quarter.substring(0, 4);
                    const month = element.quarter.substring(4, 6);
                    element.quarter = `${year}/${month}`;
                    element.languageId = element.languageId === 1 ? t('language.turkish') : t('language.english');
                });

                // Büyükten küçüğe sıralama
                data.sort((a, b) => {
                    const dateA = new Date(a.quarter);
                    const dateB = new Date(b.quarter);
                    return dateB - dateA;
                });

                setReportListData(data);
                setIsLoading(false)
            })

            .catch((err) => {

                // console.log(err);
                setIsLoading(false)
                setPanelError(true)

            });
    }

    //#endregion REPORTDATA
    //#endregion API CALLS

    const handleClickReportCategory = (item) => {

        setstateReportCategoryActive([{ id: item.id }])
        //getData(id)
    }

    const downLoadReport = (item) => {
        console.log('downLoadReport', item);
        try {
            if (!token || !item.id) {
                console.error('Token or item ID is missing');
                return;
            }

            toast.current.show({ severity: 'info', summary: t('reports.reportDownloading'), detail: t('pleaceWait') });
            attachmentApi.attachmentDownloadReportGet(item.id, token, { responseType: 'blob' }).then((response) => {
                console.log("attachmentApi: ", response);
                downloadPdf(response, item);
                setTimeout(() => {
                    toast.current.show({ severity: 'success', summary: t('reports.reportDownloaded'), detail: t('reports.reportSaveİsAllReady') });
                }, 500);
            }).catch((error) => {
                console.error('Error downloading report:', error);
            });

        } catch (error) {
            console.error('downLoadReport caught an exception:', error);
        }
    };

    const templateNameHandler = (template) => {
        if (!template) return '';

        if (template.includes('_')) {

            let tempStrLen = template.split('_').length;

            if (tempStrLen > 2) {
                return template.split('_')[0] + '_' + template.split('_')[1];
            }
        }

        else if (template.includes('-')) {
            let tempStrLen = template.split('-').length;

            if (tempStrLen > 2) {
                return template.split('-')[0] + '-' + template.split('-')[1];
            }


        }

        return template;
    }

    const templateNameLen = (template) => {
        if (!template) return '';

        if (template.includes('_')) {

            let tempStrLen = template.split('_').length;

            return tempStrLen;
        }

        else if (template.includes('-')) {
            let tempStrLen = template.split('-').length;

            return tempStrLen;
        }

        return template.length;
    }

    return (
        <div id='stockAnalysisReport'>
            <Toast ref={toast} position='bottom-right' />

            <Container className='m-t-30'>
                <Row className='m-t-5'>
                    <Col className='p-0'>
                        <ParallelButtonSelection titles={reportListTitles} activeTitle={stateReportategoryActive[0].id} clickTitle={handleClickReportCategory} />
                    </Col>
                </Row>
            </Container>

            <Row className='reportList m-t-15'>
                {panelError && <ErrorContent />}
                {isLoading && <Spinner height="800px" />}
                {!isLoading && !panelError && (
                    reportListData.length > 0 ? reportListData.map((item, index) => (
                        <Col md="3" key={item.id} onClick={() => downLoadReport(item)} style={{ marginBottom: "15px" }}>
                            <div key={item.id} className={[`reportListItem ${selectedTheme == 'dark' ? 'dark-reportListItem' : 'light-reportListItem'} `]}>
                                <Row>
                                    <div className='iconDiv'>
                                        <span className="icon"><FontAwesomeIcon icon={faDownload} /></span>
                                    </div>
                                    <Col className='reportLeft roboto-bold-14'>

                                        <div className={`templateDiv ${item.template.length > 5 ? 'font-12' : ''}`}>
                                            <span>{templateNameHandler(item.template)}</span>
                                        </div>
                                    </Col>
                                    <Col className='reportCenter'>
                                        {/* <label>{item.Name}</label> */}
                                        <Image src={reportImage} className='centerDivImage' />
                                    </Col>
                                    <Col className='reportRight'>
                                        <label className='quaterSpan roboto-bold-14'>{item.quarter}</label>
                                        <label className='languageSpan roboto-bold-14'>{item.languageId}</label>
                                    </Col>
                                </Row>

                            </div>
                        </Col>
                    )) : (
                        <Col xs="12" className="emptyReportList text-center p-4">
                            {stateReportategoryActive[0].id === 17
                                ? t('reports.noCompanyPresentation')
                                : t('reports.noReports')}
                        </Col>
                    )

                )}


            </Row >
        </div >
    )
}
